import { useEffect } from "react";

const siteName = "Annwesha Research Journal";
const defaultDescription = "Annwesha is a peer-reviewed research journal published by the Department of Bengali, Srikishan Sarda College, Hailakandi.";

const setMeta = (selector, attribute, value) => {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }
  const [name, content] = attribute;
  element.setAttribute(name, content);
  element.setAttribute("content", value);
};

export const Seo = ({ title, description = defaultDescription, path = "/", noIndex = false }) => {
  useEffect(() => {
    const pageTitle = title ? `${title} | ${siteName}` : siteName;
    const canonicalUrl = new URL(path, window.location.origin).href;

    document.title = pageTitle;
    setMeta('meta[name="description"]', ["name", "description"], description);
    setMeta('meta[property="og:title"]', ["property", "og:title"], pageTitle);
    setMeta('meta[property="og:description"]', ["property", "og:description"], description);
    setMeta('meta[property="og:url"]', ["property", "og:url"], canonicalUrl);
    setMeta('meta[name="twitter:title"]', ["name", "twitter:title"], pageTitle);
    setMeta('meta[name="twitter:description"]', ["name", "twitter:description"], description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;

    let robots = document.head.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    robots.content = noIndex ? "noindex, nofollow" : "index, follow";

    if (!noIndex) {
      let structuredData = document.getElementById("annwesha-structured-data");
      if (!structuredData) {
        structuredData = document.createElement("script");
        structuredData.id = "annwesha-structured-data";
        structuredData.type = "application/ld+json";
        document.head.appendChild(structuredData);
      }
      structuredData.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteName,
        url: window.location.origin,
        email: "annweshajournal@gmail.com",
        description: defaultDescription,
        parentOrganization: {
          "@type": "CollegeOrUniversity",
          name: "Srikishan Sarda College, Hailakandi",
        },
      });
    }
  }, [title, description, path, noIndex]);

  return null;
};
